import React,{useEffect,useState} from "react";
import {Button,Table,Tag,Typography,Alert,Space,Grid} from "antd";
import {ReloadOutlined,DownloadOutlined} from "@ant-design/icons";
import axios from "axios";
import {API_BASE} from "./components/ledger/LedgerResponsive";

const {Title,Text}=Typography;
export default function ReportDownloads(){
 const screens=Grid.useBreakpoint(),isMobile=!screens.md;
 const [rows,setRows]=useState([]),[loading,setLoading]=useState(false),[error,setError]=useState("");
 const load=async()=>{setLoading(true);setError("");try{
   const r=await axios.get(`${API_BASE}/report_downloads_list.php`);
   setRows(r.data?.reports||[]);
 }catch(e){setError(e?.response?.data?.message||"Could not load report downloads.");}finally{setLoading(false);}};
 useEffect(()=>{load();},[]);
 const status=(r)=>{
   if(r.status==="ready") return <Tag color="green">Ready</Tag>;
   if(r.status==="failed") return <Tag color="red">Failed</Tag>;
   if(r.status==="retrying") return <Tag color="orange">Retrying</Tag>;
   return <Tag color="blue">{r.status_text||"Preparing"}</Tag>;
 };
 const desktopCols=[
  {title:"Report Name",dataIndex:"report_name",key:"report_name",render:v=><Text strong>{v}</Text>},
  {title:"Format",dataIndex:"output_format",key:"output_format",width:90,render:v=><Tag>{String(v||"pdf").toUpperCase()}</Tag>},
  {title:"Ordered On",dataIndex:"created_at",key:"created_at",width:180},
  {title:"Status",key:"status",width:180,render:(_,r)=>status(r)},
  {title:"Download",key:"download",width:130,render:(_,r)=>r.status==="ready"&&r.download_token?
    <Button type="primary" size="small" icon={<DownloadOutlined/>}
      onClick={()=>window.location.assign(`${API_BASE}/report_download.php?job_id=${encodeURIComponent(r.job_id)}&download_token=${encodeURIComponent(r.download_token)}`)}>
      Download
    </Button>:<Text type="secondary">Preparing</Text>}
 ];
 const mobileCols=[desktopCols[0],desktopCols[3],desktopCols[4]]; const cols=isMobile?mobileCols:desktopCols;
 return <div style={{padding:24}}>
   <Space style={{width:"100%",justifyContent:"space-between",marginBottom:16}}>
    <div><Title level={3} style={{margin:0}}>Report Downloads</Title>
    <Text type="secondary">Ready reports remain available for 24 hours after preparation.</Text></div>
    <Button icon={<ReloadOutlined/>} onClick={load} loading={loading}>Refresh</Button>
   </Space>
   {error&&<Alert type="error" message={error} showIcon style={{marginBottom:14}}/>}
   <Table rowKey="job_id" columns={cols} dataSource={rows} loading={loading} pagination={{pageSize:20}} scroll={isMobile?undefined:{x:760}} tableLayout={isMobile?"fixed":"auto"} className={isMobile?"kg-mobile-nowrap-table":""}/>
 </div>;
}